import { useQuery } from '@tanstack/react-query';
import { Navigate } from 'react-router-dom';

import { adminFetch, clearTokens, getAccessToken } from './api';

export interface AdminProfile {
  id: number;
  email: string;
  role: string;
  totp_enabled: boolean;
  last_login_at: string | null;
}

export function useCurrentAdmin() {
  return useQuery({
    queryKey: ['auth', 'me'],
    queryFn: () => adminFetch<AdminProfile>('/api/v1/auth/me'),
    enabled: Boolean(getAccessToken()),
    retry: false,
  });
}

export function logout(): void {
  void adminFetch('/api/v1/auth/logout', { method: 'POST' }).catch(() => undefined);
  clearTokens();
  window.location.href = '/login';
}

export function ProtectedRoute({ children }: { children: React.ReactNode }) {
  const token = getAccessToken();
  const me = useCurrentAdmin();

  if (!token) {
    return <Navigate to="/login" replace />;
  }
  if (me.isError) {
    clearTokens();
    return <Navigate to="/login" replace />;
  }
  if (me.isPending) {
    return (
      <div className="flex h-screen items-center justify-center text-muted-foreground">
        Loading…
      </div>
    );
  }
  return <>{children}</>;
}
